import { useTranslation } from "react-i18next";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials } from "../../store/slices/authSlice";
import { clearApp } from "../../store/slices/appSlice";
import { clear } from "../../store/slices/noteSlice";
import { useLogoutMutation } from "../../store/api/usersApiSlice";
import { useFirebase } from "../../hooks";
import { toast } from "react-toastify";


const Logout = () => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getFCMToken } = useFirebase();
  const user = useSelector(state => state.auth.user)

  const [logout] = useLogoutMutation()

  const handleLogout = async () => {
    try {
      const token = await getFCMToken()
      console.log('[Logout/index.js] Logout işlemi başlatılıyor - Token:', token, 'User ID:', user.id);
      const res = await logout({
        deviceToken: token,
        id: user.id
      }).unwrap();

      if (res.isSuccess) {
        dispatch(clearCredentials());
        dispatch(clearApp())
        dispatch(clear())
        window.location.replace("/login");
      } else throw new Error(JSON.stringify(res.error))
    } catch (err) {
      console.log('[Logout/index.js] Logout hatası:', err)
      toast.error(t('refresh_page'))
    }
  }

  useEffect(() => {
    handleLogout()
  }, [])

  // useEffect(() => {
  //     if(isAuthenticated === false && user.id === undefined) {
  //         window.location.replace("/login");
  //     }
  // }, [isAuthenticated, user])

  return (
    <Backdrop
      open={true}
      sx={{
        color: (theme) => theme.palette.primary.main,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 3
      }}
    >
      <CircularProgress
        size={60}
        color="inherit"
        sx={{
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }}
      />
      <Typography
        variant="h5"
        sx={{
          color: 'inherit',
          fontWeight: 600,
          textAlign: 'center',
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}
      >
        Çıkış yapılıyor...
      </Typography>
    </Backdrop>
  )
}

export default Logout;